import type { FareRuleParams } from 'api/flights'
import Modal from 'LuxKit/Modal/Modal'
import { useIntl } from 'react-intl'
import FlightFareRulesModalContent from './FlightFareRulesModalContent'
import useModalElementContext from 'hooks/Modal/useModalElementContext'

interface Props {
  urls: Array<string>
  params?: FareRuleParams
}

function FlightFareRulesModal(props: Props) {
  const { urls, params } = props
  const intl = useIntl()
  const modal = useModalElementContext()
  const modalClose = () => modal.resolve()

  return <Modal
    size="L"
    title={intl.formatMessage({
      id: 'voqRwzaj5wWmLSuFO3Zb',
      defaultMessage: 'Fare Rules',
      description: 'Title for the flight fare rules modal in the flight search or booking flow',
    })}
    primaryActionText={intl.formatMessage({
      id: 'X37MWjNsM4wA-f221Scu',
      defaultMessage: 'Ok',
      description: 'Button text to close the fare rules modal dialog window',
    })}
    onPrimaryActionClick={modalClose}
    data-testid="fare-rules"
  >
    <FlightFareRulesModalContent
      urls={urls}
      params={params}
    />
  </Modal>
}

export default FlightFareRulesModal
